import "./instrument";
import "./index.css";
import "./i18n";

import * as Sentry from "@sentry/react";

import { persistor, store } from "@store/index";

import App from "App";
import { AuthProvider } from "@service";
import LocalizedDatesProvider from "@components/common/LocalizedDatesProvider";
import { BrowserRouter } from "react-router-dom";
import { Constants } from "@utils/api-communication/ApiConstants";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { getUsername } from "@utils/CommonUtil";
import { createAxiosInstance } from "@utils/axios-config/axios_config";
import { createRoot } from "react-dom/client";
import { setUserIntegration } from "@utils";

if (process.env.NODE_ENV !== "production") {
  import("@store/debug/stateTrace")
    .then(({ installStateTrace }) => installStateTrace(store))
    .catch((error) => console.warn("State trace unavailable:", error));
}

const container = document.getElementById("root");
if (!container) throw new Error("Root container missing in index.html");

const root = createRoot(container, {
  onRecoverableError: Sentry.reactErrorHandler(),
});

async function initSystem() {
  await Constants.construct();
  createAxiosInstance();
  await setUserIntegration(getUsername());

  root.render(
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: "2rem", textAlign: "center", fontFamily: "sans-serif" }}>
          <h2>Oops! Something went wrong.</h2>
          <p>An unexpected error occurred. Reloading the page usually fixes it.</p>
          <a href="/">Reload</a>
        </div>
      }
    >
      <Provider store={store}>
        <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
          <BrowserRouter>
            <AuthProvider>
              <LocalizedDatesProvider>
                <App />
              </LocalizedDatesProvider>
            </AuthProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </Sentry.ErrorBoundary>,
  );
}

initSystem().then(() => {
  console.log("✅ System initialized once");
});
